<div class="card-base">
    <div class="card-content-reservation-search">
        <div class="chip-container">
            <mat-chip-list>
                <mat-chip color="accent" matTooltip="{{ filt.toolTip }}" selected *ngFor="let filt of searchFilters">
                    {{ filt.valueView }}
                    <mat-icon *ngIf="!filt.isRequired" (click)="filt.remove()">cancel</mat-icon>
                </mat-chip>
            </mat-chip-list>
        </div>
        <div class="card-container mat-elevation-z1">
            <div class="clearfix">
                <div class="pull-right div-header-right">
                    <button class="card-inline margin-top-medium" [matMenuTriggerFor]="columnsMenu" type="button" mat-mini-fab matTooltip="Columnas visibles">
                        <mat-icon>view_column</mat-icon>
                    </button>

                    <button *ngIf="!loadingAction" class="card-inline margin-top-medium" [matMenuTriggerFor]="menuItem" type="button" mat-mini-fab>
            <mat-icon>more_vert</mat-icon>
          </button>

                    <mat-spinner [diameter]="50" *ngIf="loadingAction"></mat-spinner>
                    <mat-menu #menuItem="matMenu">
                        <button (click)="changeStatePartial()" mat-menu-item>
              <span> <b>Parcialmente controlado</b></span>
            </button>
                        <button (click)="changeStateControl()" mat-menu-item>
              <span> <b>Controlado</b></span>
            </button>
                        <mat-divider></mat-divider>
                        <button (click)="exportStudyReport()" mat-menu-item>
              <span> <b>Preparar descarga de informes…</b></span>
            </button>
                        <button (click)="exportImages()" mat-menu-item>
              <span> <b>Preparar descarga de imágenes…</b></span>
            </button>
                        <button (click)="preBilling()" mat-menu-item>
              <span> <b>Programar prefacturación</b></span>
            </button>
                        <button (click)="validateOnLine()" mat-menu-item>
              <span> <b>Programar validación on line</b></span>
            </button>

                        <button (click)="exportAttached()" mat-menu-item>
              <span> <b>Preparar descarga de adjuntos…</b></span>
            </button>
                        <mat-divider></mat-divider>
                        <button (click)="changeStateNoBilling()" mat-menu-item>
              <span> <b>No facturar</b></span>
            </button>
                        <button (click)="changeStateDown()" mat-menu-item>
              <span> <b>Baja</b></span>
            </button>
                        <mat-divider></mat-divider>
                        <button (click)="rollBack()" mat-menu-item>
              <span> <b>Revertir</b></span>
            </button>
                        <mat-divider></mat-divider>
                        <button (click)="exportCsv()" mat-menu-item>
              <span> <b>Exportar a csv</b></span>
            </button>
                        <mat-divider></mat-divider>
                        <button (click)="massivePrint()" mat-menu-item>
              <span> <b>Imprimir informes</b></span>
            </button>
                    </mat-menu>

                    <mat-menu #columnsMenu="matMenu" class="columns-menu">
                        <button mat-menu-item (click)="showAllColumns()">
                            <span>Mostrar todas</span>
                        </button>
                        <mat-divider></mat-divider>
                        <div class="columns-menu-item" *ngFor="let col of availableColumns" (click)="$event.stopPropagation()">
                            <mat-checkbox [checked]="isColumnVisible(col.field)" (click)="$event.stopPropagation()" (change)="setColumnVisibility(col.field, $event.checked)">
                                {{ col.title }}
                            </mat-checkbox>
                        </div>
                    </mat-menu>
                </div>
                <div class="pull-left div-header-left">
                    <app-billing-close-filter #billingCloseFilter (onUserFilterLoad)="onUserFilterLoad()" (onInitSearch)="onEndSearch($event)" #filters></app-billing-close-filter>

                    <app-search-filter-component #searchFilter (startSearch)="onStartSearch()" (endSearch)="onEndSearch($event)" (copyFilter)="copyFilter()" [canCopyFilter]="true" [filter]="filters"></app-search-filter-component>


                </div>
            </div>
            <mat-divider></mat-divider>
            <div class="card-content margin-botton-medium">
                <mat-spinner *ngIf="loading"></mat-spinner>
                <div *ngIf="!loading" class="grid-scroll-container">
                    <p-table class="search-table" [value]="dataSource" [tableStyle]="{ width: '100%' }">
                        <ng-template pTemplate="header">
                            <tr class="search-table-header">
                                <th class="checkbox-column">
                                    <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()">
                                    </mat-checkbox>
                                </th>
                                <th class="resizable-header" *ngFor="let col of orderedColumnsDefinition" [style.width.px]="getColumnWidth(col.field)" (dragover)="onHeaderDragOver($event)" (drop)="onHeaderDrop($event, col.field)">
                                    <div class="header-top-row">
                                        <span class="header-drag-content">
                                            <span class="column-title" (click)="sortByColumn(col.field)">
                                                {{ col.title }}
                                                <mat-icon class="sort-icon">{{ getSortIcon(col.field) }}</mat-icon>
                                            </span>
                                        <mat-icon class="header-drag-handle" draggable="true" (dragstart)="onHeaderDragStart($event, col.field)" (dragend)="onHeaderDragEnd()" (click)="$event.stopPropagation()">drag_indicator</mat-icon>
                                        </span>
                                        <span class="column-resize-handle" (mousedown)="startResize($event, col.field)"></span>
                                    </div>
                                    <input class="column-filter-input" [value]="columnFilters[col.field] || ''" (click)="$event.stopPropagation()" (input)="onColumnFilterInput(col.field, $event.target.value)" placeholder="Filtrar" />
                                </th>
                                <th class="actions-column"></th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-element>
                            <tr class="search-table-cell" [class.disabled-item-row]="isSectorMismatch(element)" (dblclick)="viewOrdenControl(element)">
                                <td class="checkbox-column">
                                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(element) : null" [checked]="selection.isSelected(element)">
                                    </mat-checkbox>
                                </td>
                                <td *ngFor="let col of orderedColumnsDefinition" [style.width.px]="getColumnWidth(col.field)">
                                    <ng-container [ngSwitch]="col.field">
                                        <span *ngSwitchCase="'billingDate'">{{ element.billingDate | date : "dd/MM/yyyy HH:mm" }}</span>
                                        <span *ngSwitchCase="'practiceName'">{{ element.setName ? element.setName : element.practiceName }}</span>
                                        <span *ngSwitchCase="'hasNoBillingObservation'">{{ element.hasNoBillingObservation ? "Sí" : "No" }}</span>
                                        <span *ngSwitchCase="'noBillingName'">
                                            <span>{{ element.noBillingName }}</span>
                                        <mat-icon *ngIf="hasNoBillingObservationIndicator(element)" class="no-billing-observation-icon" matTooltip="Tiene observaciones de No Facturar">warning</mat-icon>
                                        </span>
                                        <span *ngSwitchDefault>{{ element[col.field] }}</span>
                                    </ng-container>
                                </td>
                                <td class="actions-column" (click)="$event.stopPropagation()">
                                    <mat-spinner *ngIf="element.Loading" [diameter]="15"></mat-spinner>

                                    <button *ngIf="!element.Loading" mat-icon-button [matMenuTriggerFor]="rowMenu">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #rowMenu="matMenu">
                                        <button (click)="viewOrdenControl(element)" mat-menu-item>
                                            <span>Ver</span>
                                        </button>
                                        <button (click)="openAdmisionLogViewDialog(element)" mat-menu-item>
                                            <span>Actividades admisión</span>
                                        </button>
                                        <button (click)="openBillingLogViewDialog(element)" mat-menu-item>
                                            <span>Actividades facturación</span>
                                        </button>

                                        <button (click)="openMedicalAppointmentObservationDialog(element)" mat-menu-item>
                                            <span>Observaciones</span>
                                        </button>
                                    </mat-menu>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
                <pager [info]="info" [selectedAmount]="selected" [onPage]="seeTotals" [exportColumnsName]="exportColumnsName" [exportColumns]="exportColumns" (selectedPageIndexChange)="selectedPageIndexChange($event)" #pager></pager>
            </div>
        </div>
    </div>
</div>